import React from "react";
import LoadingOverlay from "react-loading-overlay";

const LoadingComponent = ({ children, isLoading }) => {
  return (
    <LoadingOverlay
      spinner
      active={isLoading}
      styles={{
        overlay: (base) => ({
          ...base,
          background: "rgba(255, 255, 255, 0.8)",
        }),
        spinner: (base) => ({
          ...base,
          "& svg circle": {
            stroke: "rgb(17, 73, 123)",
          },
        }),
      }}
    >
      {children}
    </LoadingOverlay>
  );
};

export default LoadingComponent;
